import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

require("./MyStableButton.scss");

export default class MyStableCross extends PureComponent {

  static propTypes = {
    deleteSubscriptions: PropTypes.func
  };

  render() {
    const {
      deleteSubscriptions = () => {}
    } = this.props;

    return (
      <a className="my-stable-selections-remove" id="my-stable-selections-remove" href="#" onClick={ () => deleteSubscriptions() }>&times;</a>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Common/containers/Subscriptions/MyStableCross.js